import { contributionsReducer } from 'app/store/Contributions/slice';
import { songListReducer } from 'app/store/SongList/slice';
import { settingsReducer } from 'app/store/Settings/slice';
import { profileReducer } from 'app/store/Profile/slice';
import { alertsReducer } from 'app/store/Alerts/slice';
import { authReducer } from 'app/store/Auth/slice';
import { electronReducer } from 'app/store/Electron/slice';
import { countriesReducer } from 'app/store/Countries/slice';
import { notificationsReducer } from 'app/store/Notifications/slice';
import { audioPlayerReducer } from 'app/store/AudioPlayer/slice';
import { releasesReducer } from 'app/store/Releases/slice';
import { sharesReducer } from 'app/store/Shares/slice';
import { intercomReducer } from 'app/store/Intercom/slice';
import { webSocketsReducer } from 'app/store/WebSockets/slice';
import { mixpanelReducer } from 'app/store/Mixpanel/slice';
import { subscriptionReducer } from 'app/store/Subscription/slice';
import { globalSearchReducer } from 'app/store/GlobalSearch/slice';
import { storageReducer } from 'app/store/Storage/slice';
import { playlistsReducer } from 'app/store/Playlists/slice';
import { chatReducer } from 'app/store/Chat/slice';
import { importReducer } from 'app/store/Import/slice';

export const rootReducers = {
  contributions: contributionsReducer,
  songList: songListReducer,
  settings: settingsReducer,
  profile: profileReducer,
  alerts: alertsReducer,
  auth: authReducer,
  electron: electronReducer,
  countries: countriesReducer,
  notifications: notificationsReducer,
  audioPlayer: audioPlayerReducer,
  releases: releasesReducer,
  shares: sharesReducer,
  intercom: intercomReducer,
  webSockets: webSocketsReducer,
  mixpanel: mixpanelReducer,
  subscription: subscriptionReducer,
  globalSearch: globalSearchReducer,
  storage: storageReducer,
  playlists: playlistsReducer,
  chat: chatReducer,
  import: importReducer,
};
